/* eslint-disable import/no-duplicates */
/* eslint-disable no-unused-vars */
/**

* � [2020] Conduent, Inc. All rights reserved. Conduent�and Conduent Agile

* Star�are trademarks of Conduent, Inc. and/or its subsidiaries in the United

* States and/or other countries.

*/

import React from 'react';
import { connect } from 'react-redux';
import { Route, Switch, Redirect } from 'react-router-dom';
import * as RouteUrls from "./RouteConstants";
import Dashboardsearch from '../../SharedModules/Dashboard/dashboard';
import ValidvalueSearch from '../../Modules/ApplicationConfiguration/Components/ValidValue/ValidvalueSearch';
import ValidvalueView from '../../Modules/ApplicationConfiguration/Components/ValidValue/ValidvalueView';
import SystemListSearch from '../../Modules/ApplicationConfiguration/Components/SystemList/Search/SystemListSearch';
import SystemListAdd from '../../Modules/ApplicationConfiguration/Components/SystemList/Add/SystemListAdd';
import SystemParameterSearch from '../../Modules/ApplicationConfiguration/Components/SystemParameter/SystemParameter';
import SystemParameterAdd from '../../Modules/ApplicationConfiguration/Components/SystemParameter/Add/SystemParameterAdd';
import SystemParameterUpdate from '../../Modules/ApplicationConfiguration/Components/SystemParameter/SystemParameterUpdate';
import SystemListAddUpdate from '../../Modules/ApplicationConfiguration/Components/SystemList/Search/SystemListAddUpdate';
import MapSetSearch from '../../Modules/ApplicationConfiguration/Components/MapSet/MapSet';
import MapSetAdd from '../../Modules/ApplicationConfiguration/Components/MapSet/MapSetAdd';
import MapSetEdit from '../../Modules/ApplicationConfiguration/Components/MapSet/MapSetAdd';
import TextManagementSearch from '../../Modules/ApplicationConfiguration/Components/TextManagement/TextManagementSearch';
import TextUpdate from '../../Modules/ApplicationConfiguration/Components/TextManagement/TextUpdate';
import TextAddUpdate from '../../Modules/ApplicationConfiguration/Components/TextManagement/TextAddUpdate';
import BankAccountAndLockbox from '../../Modules/BankAccountAndLockbox/Components/BankAccountAndLockBox';
import BankAccountAndLockBoxAdd from '../../Modules/BankAccountAndLockbox/Components/BankAccountAndLockBoxAdd';
import FinancialBudgetSearch from '../../Modules/BudgetMaintenance/Components/FinancialBudgetSearch';
import BudgetDataUpdate from '../../Modules/BudgetMaintenance/Components/Update/BudgetDataUpdate';
import BudgetMaintenanceAdd from '../../Modules/BudgetMaintenance/Components/Add/BudgetMaintenanceAdd';
import FinancialAccountInquiry from '../../Modules/AccountReceivables/Components/ARInquiryUpdate/ARSearch/FinancialAccountInquiry';
import FCNPayOutSearchResults from '../../Modules/FinancialPayOut/components/FPSearch/FCNSearchResults';
import FinancialPayOutAdd from '../../Modules/FinancialPayOut/components/FinancialPayOutAddAndUpdate/PayoutAddComponent';
import FinancialPayOutUpdate from '../../Modules/FinancialPayOut/components/FinancialPayOutAddAndUpdate/PayoutAddComponent';
import FCNSearchResults from '../../Modules/AccountReceivables/Components/ARInquiryUpdate/ARSearch/FCNSearchResults';

import MCNSearchResults from '../../Modules/AccountReceivables/Components/ARInquiryUpdate/ARSearch/MCNSearchResults';
import PayeeSearchResults from '../../Modules/AccountReceivables/Components/ARInquiryUpdate/ARSearch/PayeeSearchResults';
import BankAccountAndLockBoxEdit from '../../Modules/BankAccountAndLockbox/Components/BankAccountAndLockBoxEdit';
import FinancialEntitySearch from '../../Modules/FinancialEntities/Components/FinancialEntitySearch';
import FinancialEntityAdd from '../../Modules/FinancialEntities/Components/FinancialEntityAdd/FinancialEntityAdd';
import FinancialAccountGrossLevel from '../../Modules/AccountReceivables/Components/ARInquiryUpdate/GrossLevelAdd/add/FinancialAccountGrossLevel';
import GrossLevelAddPayeeComponent from '../../Modules/AccountReceivables/Components/ARInquiryUpdate/GrossLevelAdd/add/GrossLevelAddPayeeComponent';
import ChangePassword from '../../Modules/Security/Components/ChangePassword';
import ResetPassword from '../../Modules/Security/Components/ResetPassword';
import AddUser from '../../Modules/Security/Components/AddUser';
import UserProfile from '../../Modules/Security/Components/UserProfile';
import SearchUser from '../../Modules/Security/Components/SearchUser';
import Login from '../../Login';
import FinancialReceiptSearch from '../../Modules/FinancialReceipt/Components/FinancialReceiptSearch';
import FinancialReceiptReturn from '../..//Modules/FinancialReceipt/Components/FinancialReceiptReturn';
import FinancialReceiptAdd from '../../Modules/FinancialReceipt/Components/ADD/FinancialReceiptAdd';
import FinancialReceiptReversal from '../../Modules/FinancialReceipt/Components/FinancialReceiptReversal';
import FundCodeAdd from '../../Modules/FundCode/Components/FundCodeAdd';
import FundCodeEdit from '../../Modules/FundCode/Components/FundCodeAdd';
import WriteOff from '../../Modules/WriteOffAndReEstablishment/Components/WriteOff';
import WriteOffReEstablishment from '../../Modules/WriteOffAndReEstablishment/Components/WriteOffReEstablishment';
import FundCodeSearch from '../../Modules/FundCode/Components/FundCodeSearch';
import FinancialEntityUpdate from '../../Modules/FinancialEntities/Components/FinancialEntityUpdate';
import FCNInquiryPayOut from '../../Modules/FinancialPayOut/components/FPSearch/FinancialPayoutInquiry';

import LienLevyAdd from '../../Modules/AccountReceivables/Components/ARInquiryUpdate/GrossLevelAdd/Lien Levy/add/FinancialAccountLienLevy';
import ClaimsReceivable from '../../Modules/AccountReceivables/Components/ClaimsReceivables/ClaimsReceivable';
import PayoutApprovalSearchForm from '../../Modules/AccountPayables/Components/PayoutApproval/PayoutApprovalSearchForm';
import FiscalPendCriteriaAdd from '../../Modules/FiscalPendCriteria/Components/FiscalPendCriteriaAdd';
import LienLevyUpdate from '../../Modules/AccountReceivables/Components/ARInquiryUpdate/GrossLevelAdd/Lien Levy/update/FinancialAccountLienLevy';
import GrossLevelUpdate from '../../Modules/AccountReceivables/Components/ARInquiryUpdate/GrossLevelAdd/update/FinancialAccountGrossLevelUpdate';

import ARTransfer from '../../Modules/AccountReceivables/Components/ARInquiryUpdate/ARTransfer/ARTransfer';
import FinancialReceiptAdjustment from '../../Modules/FinancialReceipt/Components/Adjustment/FinancialReceiptAdjustment';
import FiscalPendCriteriaSearch from '../../Modules/FiscalPendCriteria/Components/FiscalPendCriteriaSearch';
import ARReverse from '../../Modules/AccountReceivables/Components/ARInquiryUpdate/ARReverse/ARReverse';
import ARAdjust from '../../Modules/AccountReceivables/Components/ARInquiryUpdate/ARAdjustment/ARAdjust';
import FPAdjust from '../../Modules/FinancialPayOut/components/FinancialPayOutAddAndUpdate/PayoutAdjust';
import AdvancePayment from '../../Modules/AccountReceivables/Components/ARInquiryUpdate/AdvancePayment/AdvancePayment';
import CorrectionSearch from '../../Modules/1099Correction/Components/Search/CorrectionSearch';
import CorrectionDetailsView from '../../Modules/1099Correction/Components/Search/CorrectionDetailsView';
import CorrectionSearchApproval from '../../Modules/1099Correction/Components/CorrectionApprovalSearch/CorrectionApprovalSearch';

import ARBulkTransfer from '../../Modules/AccountReceivables/Components/BulkMaintenance/Transfer/BulkTransfer';
import ChangePayStatus from '../../Modules/AccountReceivables/Components/BulkMaintenance/ChangePayeeStatus/ChangePayeeStatus';

import ClaimFinancialInquirySearch from '../../Modules/FinancialInquiry/Components/FISearch/ClaimFinancialInquirySearch';
import PaymentStatusInquirySearch from '../../Modules/PaymentStatusInquiry/Components/PaymentStatusInquirySearch';
import ClaimsReceivables from '../../Modules/FinancialInquiry/Components/ClaimsReceivables/ClaimsReceivables';
import EventLoggingSearch from '../../Modules/ProjectControl/EventLogging/Components/EventLogSearch';
import GlobalAuditSearch from '../../Modules/ProjectControl/GlobalAuditSearch/Components/GlobalAuditSearch';
import GlobalAuditDetails from '../../Modules/ProjectControl/GlobalAuditSearch/Components/GlobalAuditDetails';
import ReissueUpdate from '../../Modules/ReceiptReissue/Components/ReissueUpdate';
import BulkMaintenance from '../../Modules/AccountReceivables/Components/BulkMaintenance/BulkMaintenance';
import EMARSearch from '../../Modules/EMAR/Components/EMARSearch';
import EMARAdd from '../../Modules/EMAR/Components/EMARAdd';
import WaiverLineSearch from '../../Modules/WaiverLine/WaiverLineSearch';
import WaiverAdd from '../../Modules/WaiverLine/WaiverLineAdd';
import FRCAdd from '../../Modules/FRC/Components/FRCAdd';
import FRCSearch from '../../Modules/FRC/Components/FRCSearch';
import CMS64Add from '../../Modules/CMS64/Components/CMS64Add';
import CMS64Search from '../../Modules/CMS64/Components/CMS64Search';
import BulkReverse from '../../Modules/AccountReceivables/Components/BulkMaintenance/Reverse/BulkReverse';
import BulkWriteOff from '../../Modules/AccountReceivables/Components/BulkMaintenance/Write-off/BulkWriteOff';
import BulkWriteOffReest from '../../Modules/AccountReceivables/Components/BulkMaintenance/Write-offReest/BulkWriteOffReest';
import FinancialUpload from '../../Modules/MassUpload/Components/DataUpload';
import FinancialUploadView from '../../Modules/MassUpload/Components/DataUploadView';
import PaymentCriteriaAdd from '../../Modules/PaymentCriteria/Components/Add/PaymentCriteriaAdd';
import PaymentCriteriaSearch from '../../Modules/PaymentCriteria/Components/Search/PaymentCriteriaSearch';
import SITEMAP from '../../Modules/ContentManagement/SiteMap';
import FOOTERLINKS from "../../Modules/ContentManagement/FooterLinks";
import MyAccount from '../Layout/MyAccount';
import { someInLeftNav } from '../../SharedModules/CommonUtilities/commonUtilities';
import * as TITLE_CONSTANTS from "./TitleConstants.js";
import ErrorMessages from '../Errors/ErrorMessages';

global.enableSpinner = !(localStorage.getItem("IsAddOrCancel") === "Add")  && !someInLeftNav() || (localStorage.getItem("IsAddOrCancel") === "Cancel");
localStorage.removeItem('IsAddOrCancel');  

// Same access check as navigationMenu (for direct URL hit to insight routes)
function someInMenus(menuItem, path) {
  if (menuItem.rootUrl === path || menuItem.url === path) return true;
  if (menuItem.assocURLs && menuItem.assocURLs.some((u) => path.includes(u))) return true;
  if (menuItem.children?.length) return menuItem.children.some((el) => someInMenus(el, path));
  return false;
}
function checkAccess(path) {
  try {
    const ls = localStorage.getItem("loginState");
    if (!ls) return false;
    const loginState = JSON.parse(ls);
    const menuItems = loginState?.menuItems;
    if (!menuItems?.length) return false;
    return menuItems.some((e) => someInMenus(e, path));
  } catch (_) {
    return false;
  }
}

const ACCESS_DENIED_MSG = "Either you don't have permission to access this page or this page does not exist.";

// Direct URL hit to insight routes: keep URL as /OperationalInsights (or /PerformanceInsights), show dashboard content.
// (External insight URL is only opened when user clicks the side menu link.)
const InsightRouteHandler = ({ path }) => {
  const [accessDenied, setAccessDenied] = React.useState(false);
  React.useEffect(() => {
    if (!checkAccess(path)) {
      setAccessDenied(true);
    }
  }, [path]);
  if (accessDenied) {
    return (
      <div className="pos-relative w-100 h-100">
        <ErrorMessages errorMessages={[ACCESS_DENIED_MSG]} />
      </div>
    );
  }
  return <Dashboardsearch />;
};

const OwnRoute = props => {
  const { path, Component, title } = props;
  React.useEffect(() => {
    document.title = title
  }, [path]);
  return (
    <Route
      path={path}
      render={props =>
          <Component {...props} />
      }
    />
  );
};


const CustomRoute = connect()(OwnRoute);

const routes = (
  <Switch>
      <CustomRoute path={RouteUrls.DASHBOARD} Component={Dashboardsearch} title={TITLE_CONSTANTS.DASHBOARD_MODULE}/>
       <CustomRoute path={RouteUrls.My_ACCOUNT} Component={MyAccount} title={TITLE_CONSTANTS.MYACCOUNT_MODULE}/>
       {/* Application Configuration start */}       
       <CustomRoute path={RouteUrls.VALID_VALUE_SEARCH} Component={ValidvalueSearch} title={TITLE_CONSTANTS.VALID_VALUE_MODULE}/>
       <CustomRoute path={RouteUrls.VALID_VALUE_VIEW} Component={ValidvalueView} title={TITLE_CONSTANTS.VALID_VALUE_MODULE}/>
       <CustomRoute path={RouteUrls.SYSTEM_LIST} Component={SystemListSearch} title={TITLE_CONSTANTS.SYSTEM_LIST_MODULE}/>
       <CustomRoute path={RouteUrls.SYSTEM_LIST_ADD} Component={SystemListAdd} title={TITLE_CONSTANTS.SYSTEM_LIST_MODULE}/>
       <CustomRoute path={RouteUrls.SYSTEM_PARAMETER} Component={SystemParameterSearch} title={TITLE_CONSTANTS.SYSTEM_PARAMETER_MODULE}/>
       <CustomRoute path={RouteUrls.SYSTEM_PARAMETER_ADD} Component={SystemParameterAdd} title={TITLE_CONSTANTS.SYSTEM_PARAMETER_MODULE}/>
       <CustomRoute path={RouteUrls.SYSTEM_PARAMETER_EDIT} Component={SystemParameterUpdate} title={TITLE_CONSTANTS.SYSTEM_PARAMETER_MODULE} />
       <CustomRoute path={RouteUrls.SYSTEM_LIST_ADD_UPDATE} Component={SystemListAddUpdate} title={TITLE_CONSTANTS.SYSTEM_LIST_MODULE}/>
       <CustomRoute path={RouteUrls.MAPSET_SEARCH} Component={MapSetSearch} title={TITLE_CONSTANTS.MAP_DEFINITION_MODULE}/>
       <CustomRoute path={RouteUrls.MAPSET_ADD} Component={MapSetAdd} title={TITLE_CONSTANTS.MAP_DEFINITION_MODULE}/>
       <CustomRoute path={RouteUrls.MAPSET_EDIT} Component={MapSetEdit} title={TITLE_CONSTANTS.MAP_DEFINITION_MODULE}/>
       <CustomRoute path={RouteUrls.TEXT_MANAGEMENT_SEARCH} Component={TextManagementSearch} title={TITLE_CONSTANTS.TEXT_MANAGEMENT_MODULE}/>
       <CustomRoute path={RouteUrls.TEXT_UPDATE} Component={TextUpdate} title={TITLE_CONSTANTS.TEXT_MANAGEMENT_MODULE}/>
       <CustomRoute path={RouteUrls.TEXT_ADD} Component={TextAddUpdate} title={TITLE_CONSTANTS.TEXT_MANAGEMENT_MODULE}/>
       {/* Application Configuration end */}
       {/* Bank Account & LockBox start */}
       <CustomRoute path={RouteUrls.BANK_ACCOUNT_AND_LOCKBOX} Component={BankAccountAndLockbox} title={TITLE_CONSTANTS.BANK_ACCOUNT_MODULE}/>
       <CustomRoute path={RouteUrls.BANK_ACCOUNT_LOCKBOX_ADD} Component={BankAccountAndLockBoxAdd} title={TITLE_CONSTANTS.BANK_ACCOUNT_MODULE}/>
       <CustomRoute path={RouteUrls.BANK_ACCOUNT_LOCKBOX_EDIT} Component={BankAccountAndLockBoxEdit} title={TITLE_CONSTANTS.BANK_ACCOUNT_MODULE}/>
       {/* Bank Account & LockBox end */}

       {/* Budget Maintenance start */}
       <CustomRoute path={RouteUrls.FINANCIAL_BUDGET_SEARCH} Component={FinancialBudgetSearch} title={TITLE_CONSTANTS.BUDGET_MAINTENANC_MODULE}/>
       <CustomRoute path={RouteUrls.BUDGET_DATA_UPDATE} Component={BudgetDataUpdate} title={TITLE_CONSTANTS.BUDGET_MAINTENANC_MODULE}/>
       <CustomRoute path={RouteUrls.BUDGET_DATA_ADD} Component={BudgetMaintenanceAdd} title={TITLE_CONSTANTS.BUDGET_MAINTENANC_MODULE}/>
       {/* Budget Maintenance end */}

        {/* Account Receivables start */}
       <CustomRoute path={RouteUrls.FINANCIAL_ACCOUNT_INQUIRY} Component={FinancialAccountInquiry} title={TITLE_CONSTANTS.ACCOUNT_RECEIVABLE_MODULE}/>
       <CustomRoute path={RouteUrls.FCN_SEARCH_RESULTS} Component={FCNSearchResults} title={TITLE_CONSTANTS.ACCOUNT_RECEIVABLE_MODULE}/>
       <CustomRoute path={RouteUrls.GROSS_LEVEL_ADD_PAYEE_COMPONENT} Component={GrossLevelAddPayeeComponent} title={TITLE_CONSTANTS.ACCOUNT_RECEIVABLE_MODULE}/>
       <CustomRoute path={RouteUrls.FINANCIAL_ACCOUNT_GROSS_LEVEL} Component={FinancialAccountGrossLevel} title={TITLE_CONSTANTS.ACCOUNT_RECEIVABLE_MODULE}/>
       <CustomRoute path={RouteUrls.PAYEE_SEARCH_RESULTS} Component={PayeeSearchResults} title={TITLE_CONSTANTS.ACCOUNT_RECEIVABLE_MODULE}/>
       <CustomRoute path={RouteUrls.MCN_SEARCH_RESULTS} Component={MCNSearchResults} title={TITLE_CONSTANTS.ACCOUNT_RECEIVABLE_MODULE}/>
       <CustomRoute path={RouteUrls.FINANCIAL_ACCOUNT_LIEN_LEVY} Component={LienLevyAdd} title={TITLE_CONSTANTS.ACCOUNT_RECEIVABLE_MODULE}/>
       <CustomRoute path={RouteUrls.CLAIMS_RECEIVABLE} Component={ClaimsReceivable} title={TITLE_CONSTANTS.ACCOUNT_RECEIVABLE_MODULE}/>
       <CustomRoute path={RouteUrls.FINANCIAL_ACCOUNT_LIEN_LEVY_UPDATE} Component={LienLevyUpdate} title={TITLE_CONSTANTS.ACCOUNT_RECEIVABLE_MODULE}/>
       <CustomRoute path={RouteUrls.FINANCIAL_ACCOUNT_GROSS_LEVEL_UPDATE} Component={GrossLevelUpdate} title={TITLE_CONSTANTS.ACCOUNT_RECEIVABLE_MODULE}/>
       <CustomRoute path={RouteUrls.AR_TRANSFER} Component={ARTransfer} title={TITLE_CONSTANTS.ACCOUNT_RECEIVABLE_MODULE}/>
       <CustomRoute path={RouteUrls.AR_REVERSE} Component={ARReverse} title={TITLE_CONSTANTS.ACCOUNT_RECEIVABLE_MODULE}/>
       <CustomRoute path={RouteUrls.AR_ADJUST} Component={ARAdjust} title={TITLE_CONSTANTS.ACCOUNT_RECEIVABLE_MODULE}/>
       <CustomRoute path={RouteUrls.FP_ADJUST} Component={FPAdjust} title={TITLE_CONSTANTS.ACCOUNT_RECEIVABLE_MODULE}/>
       <CustomRoute path={RouteUrls.ADVANCE_PAYMENT} Component={AdvancePayment} title={TITLE_CONSTANTS.ACCOUNT_RECEIVABLE_MODULE}/>
       <CustomRoute path={RouteUrls.WRITE_OFF} Component={WriteOff} title={TITLE_CONSTANTS.ACCOUNT_RECEIVABLE_MODULE}/>
       <CustomRoute path={RouteUrls.WRITE_OFF_REESTABLISHMENT} Component={WriteOffReEstablishment} title={TITLE_CONSTANTS.ACCOUNT_RECEIVABLE_MODULE}/>
       <CustomRoute path={RouteUrls.BULK_MAINTENANCE} Component={BulkMaintenance} title={TITLE_CONSTANTS.BULK_MAINTENANCE_MODULE}/>
       <CustomRoute path={RouteUrls.AR_BULK_TRANSFER} Component={ARBulkTransfer} title={TITLE_CONSTANTS.BULK_MAINTENANCE_MODULE}/>
       <CustomRoute path={RouteUrls.BULK_REVERSE} Component={BulkReverse} title={TITLE_CONSTANTS.BULK_MAINTENANCE_MODULE}/>
       <CustomRoute path={RouteUrls.BULK_WRITE_OFF} Component={BulkWriteOff} title={TITLE_CONSTANTS.BULK_MAINTENANCE_MODULE}/>
       <CustomRoute path={RouteUrls.BULK_WRITE_OFF_REEST} Component={BulkWriteOffReest} title={TITLE_CONSTANTS.BULK_MAINTENANCE_MODULE}/>
       <CustomRoute path={RouteUrls.CHANGE_PAY_STATUS} Component={ChangePayStatus} title={TITLE_CONSTANTS.BULK_MAINTENANCE_MODULE}/>
       {/* Account Receivables end */}

       {/* Financial Entity start */}
       <CustomRoute path={RouteUrls.FINANCIAL_ENTITY_SEARCH} Component={FinancialEntitySearch} title={TITLE_CONSTANTS.FINANCIAL_ENTITY_MODULE}/>
       <CustomRoute path={RouteUrls.FINANCIAL_ENTITY_ADD} Component={FinancialEntityAdd } title={TITLE_CONSTANTS.FINANCIAL_ENTITY_MODULE}/>
       <CustomRoute path={RouteUrls.FINANCIAL_ENTITY_UPDATE} Component={FinancialEntityAdd} title={TITLE_CONSTANTS.FINANCIAL_ENTITY_MODULE}/>

       {/* Financial Entity end */}

       {/* Financial Receipt start */}
       <CustomRoute path={RouteUrls.FINANCIAL_RECEIPT_SEARCH} Component={ FinancialReceiptSearch } title={TITLE_CONSTANTS.FINANCIAL_RECEIPT_MODULE}/>
       <CustomRoute path={RouteUrls.FINANCIAL_RECEIPT_RETURN} Component={ FinancialReceiptReturn } title={TITLE_CONSTANTS.FINANCIAL_RECEIPT_MODULE}/>
       <CustomRoute path={RouteUrls.FINANCIAL_RECEIPT_ADD} Component={FinancialReceiptAdd} title={TITLE_CONSTANTS.FINANCIAL_RECEIPT_MODULE}/>
       <CustomRoute path={RouteUrls.FINANCIAL_RECEIPT_UPDATE} Component={ FinancialReceiptAdd } title={TITLE_CONSTANTS.FINANCIAL_RECEIPT_MODULE}/>
       <CustomRoute path={RouteUrls.FINANCIAL_RECEIPT_ADJUSTMENT} Component={FinancialReceiptAdjustment} title={TITLE_CONSTANTS.FINANCIAL_RECEIPT_MODULE}/>
       <CustomRoute path={RouteUrls.FINANCIAL_RECEIPT_REVERSAL} Component={FinancialReceiptReversal} title={TITLE_CONSTANTS.FINANCIAL_RECEIPT_MODULE}/>
       <CustomRoute path={RouteUrls.REISSUE_UPDATE} Component={ReissueUpdate} title={TITLE_CONSTANTS.FINANCIAL_RECEIPT_MODULE}/>
       {/* Financial Receipt end */}
       {/* Fund Code start */}
       <CustomRoute path={RouteUrls.FUND_CODE_SEARCH} Component={FundCodeSearch} title={TITLE_CONSTANTS.FUND_CODE_MODULE}/>
       <CustomRoute path={RouteUrls.FUND_CODE_ADD} Component={FundCodeAdd } title={TITLE_CONSTANTS.FUND_CODE_MODULE}/>
       <CustomRoute path={RouteUrls.FUND_CODE_EDIT} Component={FundCodeEdit} title={TITLE_CONSTANTS.FUND_CODE_MODULE}/>
       {/* Fund Code end */}
       {/* Financial Payout start */}
       <CustomRoute path={RouteUrls.FINANCIAL_PAYOUT_SEARCH} Component={FCNInquiryPayOut} title={TITLE_CONSTANTS.PAYOUT_MODULE}/>
       <CustomRoute path={RouteUrls.FCN_PAYOUT_SEARCH_RESULTS} Component={FCNPayOutSearchResults} title={TITLE_CONSTANTS.PAYOUT_MODULE}/>
       <CustomRoute path={RouteUrls.FINANCIAL_PAYOUT_ADD} Component={FinancialPayOutAdd } title={TITLE_CONSTANTS.PAYOUT_MODULE}/>
       <CustomRoute path={RouteUrls.FINANCIAL_PAYOUT_UPDATE} Component={FinancialPayOutUpdate} title={TITLE_CONSTANTS.PAYOUT_MODULE}/>
       {/* Financial Payout end */}

       {/* Accounts Payable start */}
       <CustomRoute path={RouteUrls.PAYOUT_APPROVAL_SEARCH} Component={PayoutApprovalSearchForm} title={TITLE_CONSTANTS.PAYOUT_APPROVAL_MODULE}/>

       {/* Fiscal Pend Criteria Start */}
       <CustomRoute path={RouteUrls.FISCAL_PEND_CRITERIA_ADD} Component={FiscalPendCriteriaAdd } title={TITLE_CONSTANTS.FISCAL_PEND_CRITERIA_MODULE}/>
       <CustomRoute path={RouteUrls.FISCAL_PEND_CRITERIA_EDIT} Component={FiscalPendCriteriaAdd} title={TITLE_CONSTANTS.FISCAL_PEND_CRITERIA_MODULE}/>
       <CustomRoute path={RouteUrls.FISCAL_PEND_CRITERIA_SEARCH} Component={FiscalPendCriteriaSearch} title={TITLE_CONSTANTS.FISCAL_PEND_CRITERIA_MODULE}/>
       {/* <Route path={RouteUrls.FISCAL_PEND_CRITERIA_SEARCH} component={FiscalPendCriteriaSearch} /> */}
       {/* Fiscal Pend Criteria Start */}

       {/* 1099 Correction Start */}
       <CustomRoute path={RouteUrls.CORRECTION_SEARCH} Component={CorrectionSearch} title={TITLE_CONSTANTS.MAINTAIN_1099_MODULE}/>
       <CustomRoute path={RouteUrls.CORRECTION_DETAILS_VIEW} Component={CorrectionDetailsView} title={TITLE_CONSTANTS.MAINTAIN_1099_MODULE}/>
       <CustomRoute path={RouteUrls.CORRECTION_SEARCH_APPROVAL} Component={CorrectionSearchApproval} title={TITLE_CONSTANTS.APPROVAL_1099_MODULE}/>
       {/* 1099 Correction End */}
       {/* Financial Inquiry start */}
       <CustomRoute path={RouteUrls.FINANCIAL_INQUIRY_SEARCH} Component={ClaimFinancialInquirySearch} title={TITLE_CONSTANTS.FINANCIAL_INQUIRY_MODULE}/>
       <CustomRoute path={RouteUrls.CLAIM_SUMMARY} Component={ClaimsReceivables} title={TITLE_CONSTANTS.FINANCIAL_INQUIRY_MODULE}/>
       {/* Financial Inquiry end */}
       {/* Project Control start */}
       <CustomRoute path={RouteUrls.EVENT_LOGGING} Component={EventLoggingSearch} title={TITLE_CONSTANTS.EVENT_LOGGING_MODULE}/>
       <CustomRoute path={RouteUrls.GLOBAL_AUDIT_SEARCH} Component={GlobalAuditSearch} title={TITLE_CONSTANTS.GLOBAL_AUDIT_MODULE}/>
       <CustomRoute path={RouteUrls.GLOBAL_AUDIT_DETAILS} Component={GlobalAuditDetails} title={TITLE_CONSTANTS.GLOBAL_AUDIT_MODULE}/>
       {/* Project Control end */}
       {/* EMAR Start */}
       <CustomRoute path={RouteUrls.EMAR_SEARCH} Component={EMARSearch} />
       <CustomRoute path={RouteUrls.EMAR_ADD} Component={EMARAdd} />
       <CustomRoute path={RouteUrls.EMAR_UPDATE} Component={EMARAdd} />
       {/* EMAR End*/}
       {/* Waiver Start */}
       <CustomRoute path={RouteUrls.WAIVER_SEARCH} Component={WaiverLineSearch} />
       <CustomRoute path={RouteUrls.WAIVER_ADD} Component={WaiverAdd} />
       <CustomRoute path={RouteUrls.WAIVER_UPDATE} Component={WaiverAdd} />
       {/* Waiver End */}
       {/* FRC Start*/}
       <CustomRoute path={RouteUrls.FRC_ADD} Component={FRCAdd} />
       <CustomRoute path={RouteUrls.FRC_SEARCH} Component={FRCSearch} />
       <CustomRoute path={RouteUrls.FRC_UPDATE} Component={FRCAdd} />
       {/* FRC End*/}
       {/* CMS Start*/}
       <CustomRoute path={RouteUrls.CMS64_SEARCH} Component={CMS64Search} />
       <CustomRoute path={RouteUrls.CMS64_ADD} Component={CMS64Add} />
       <CustomRoute path={RouteUrls.CMS64_UPDATE} Component={CMS64Add} />
       {/* CMS End*/}
       {/* Mass Upload Start */}
       <CustomRoute path={RouteUrls.FINANCIAL_UPLOAD} Component={FinancialUpload} title={TITLE_CONSTANTS.FINANCIAL_DATA_UPLOAD_MODULE}/>
       <CustomRoute path={RouteUrls.FINANCIAL_UPLOAD_VIEW} Component={FinancialUploadView} title={TITLE_CONSTANTS.FINANCIAL_DATA_UPLOAD_MODULE}/>
       {/* Mass Upload End */}
       {/* Payment Inquiry Status Start */}
       <CustomRoute path={RouteUrls.PAYMENT_INQUIRY_STATUS} Component={PaymentStatusInquirySearch} title={TITLE_CONSTANTS.PAYMENT_STATUS_INQUIRY_MODULE}/>
       {/* Payment Inquiry Status End */}
       {/* Payment Criteria Start */}
       <CustomRoute path={RouteUrls.PAYMENT_CRITERIA_SEARCH} Component={PaymentCriteriaSearch} title={TITLE_CONSTANTS.PAYMENT_CRITERIA_MODULE}/>
       <CustomRoute path={RouteUrls.PAYMENT_CRITERIA_ADD} Component={PaymentCriteriaAdd} title={TITLE_CONSTANTS.PAYMENT_CRITERIA_MODULE}/>
       <CustomRoute path={RouteUrls.PAYMENT_CRITERIA_EDIT} Component={PaymentCriteriaAdd} title={TITLE_CONSTANTS.PAYMENT_CRITERIA_MODULE}/>
       {/* Payment Criteria End */}
       {/* Footer Links Start */}
       <CustomRoute path={RouteUrls.SITE_MAP} Component={SITEMAP} title={TITLE_CONSTANTS.SITE_MAP_MODULE}/>
       <CustomRoute path={RouteUrls.FOOTER_LINKS} Component={FOOTERLINKS} />
       {/* Footer Links Ends */}
       {/* Insights Start - direct URL: keep as /OperationalInsights or /PerformanceInsights, show dashboard; external URL only via side menu */}
       <Route
         path={RouteUrls.OPERATIONAL_INSIGHTS}
         render={() => (
           <InsightRouteHandler path={RouteUrls.OPERATIONAL_INSIGHTS} />
         )}
       />
       <Route
         path={RouteUrls.PERFORMANCE_INSIGHTS}
         render={() => (
           <InsightRouteHandler path={RouteUrls.PERFORMANCE_INSIGHTS} />
         )}
       />
       {/* Insights Ends */}
       {/* Access denied - same message as ErrorHandler (no permission / page does not exist) */}
       <Route
         path={RouteUrls.ACCESS_DENIED}
         render={() => (
           <div className="pos-relative w-100 h-100">
             <ErrorMessages
               errorMessages={[ACCESS_DENIED_MSG]}
             />
           </div>
         )}
       />

    </Switch>
);

export default routes;